// extracted by mini-css-extract-plugin
export var breadcrumb = "CoursesCourse-module__breadcrumb___0WcNM";
export var content = "CoursesCourse-module__content___+nXCK";
export var ctaRow = "CoursesCourse-module__ctaRow___9Kgyb";
export var description = "CoursesCourse-module__description___vsAb4";
export var hero = "CoursesCourse-module__hero___Vyvee";
export var levelBadge = "CoursesCourse-module__levelBadge___-KthJ";
export var longDescription = "CoursesCourse-module__longDescription___LPF0G";
export var meta = "CoursesCourse-module__meta___czau9";
export var metaItem = "CoursesCourse-module__metaItem___HCdM6";
export var overviewCard = "CoursesCourse-module__overviewCard___eFYDc";
export var section = "CoursesCourse-module__section___JiMxK";
export var tocSection = "CoursesCourse-module__tocSection___All2Z";
export var tocSubtitle = "CoursesCourse-module__tocSubtitle___PJ85p";